"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import type { ResolvedPromoContent, DisplayMode } from "./types";
import { getLinkProps } from "./partials/promoHelpers";
import { CardVariant } from "./partials/CardVariant";
import { BannerVariant } from "./partials/BannerVariant";
import { ShowcaseVariant } from "./partials/ShowcaseVariant";
export interface PromoContentBannerProps {
  promo: ResolvedPromoContent;
  displayMode?: DisplayMode;
  fillHeight?: boolean;
}
export const PromoContentBanner: React.FC<PromoContentBannerProps> = t0 => {
  const $ = _c(27);
  const {
    promo,
    displayMode: t1,
    fillHeight: t2
  } = t0;
  const displayMode = t1 === undefined ? "banner" : t1;
  const fillHeight = t2 === undefined ? false : t2;
  const nav = useNavigation();
  const textColor = promo.textColor ?? "#FFFFFF";
  const ctaBackground = promo.ctaBackground ?? "#FFFFFF";
  const ctaTextColor = promo.ctaTextColor ?? promo.gradientFrom ?? (displayMode === "card" ? "#1a1a1a" : "#E63946");
  let t3;
  if ($[0] !== nav.basePath || $[1] !== promo.ctaLink) {
    t3 = getLinkProps(promo.ctaLink, nav.basePath);
    $[0] = nav.basePath;
    $[1] = promo.ctaLink;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    href,
    isExternal
  } = t3;
  if (displayMode === "card") {
    let t4;
    if ($[3] !== ctaBackground || $[4] !== ctaTextColor || $[5] !== fillHeight || $[6] !== href || $[7] !== isExternal || $[8] !== promo || $[9] !== textColor) {
      t4 = <CardVariant promo={promo} textColor={textColor} ctaBackground={ctaBackground} ctaTextColor={ctaTextColor} href={href} isExternal={isExternal} fillHeight={fillHeight} />;
      $[3] = ctaBackground;
      $[4] = ctaTextColor;
      $[5] = fillHeight;
      $[6] = href;
      $[7] = isExternal;
      $[8] = promo;
      $[9] = textColor;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  if (displayMode === "showcase") {
    let t4;
    if ($[11] !== ctaBackground || $[12] !== ctaTextColor || $[13] !== fillHeight || $[14] !== href || $[15] !== isExternal || $[16] !== promo || $[17] !== textColor) {
      t4 = <ShowcaseVariant promo={promo} textColor={textColor} ctaBackground={ctaBackground} ctaTextColor={ctaTextColor} href={href} isExternal={isExternal} fillHeight={fillHeight} />;
      $[11] = ctaBackground;
      $[12] = ctaTextColor;
      $[13] = fillHeight;
      $[14] = href;
      $[15] = isExternal;
      $[16] = promo;
      $[17] = textColor;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    return t4;
  }
  let t4;
  if ($[19] !== ctaBackground || $[20] !== ctaTextColor || $[21] !== fillHeight || $[22] !== href || $[23] !== isExternal || $[24] !== promo || $[25] !== textColor) {
    t4 = <BannerVariant promo={promo} textColor={textColor} ctaBackground={ctaBackground} ctaTextColor={ctaTextColor} href={href} isExternal={isExternal} fillHeight={fillHeight} />;
    $[19] = ctaBackground;
    $[20] = ctaTextColor;
    $[21] = fillHeight;
    $[22] = href;
    $[23] = isExternal;
    $[24] = promo;
    $[25] = textColor;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  return t4;
};